import React, {useState, useLayoutEffect, useRef} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useEventListener } from 'react-recipes'

import ButtonArrow from './buttonArrow'
import ButtonClose from './buttonClose'

import trads from '../intl/trads.json'

import scrollManager from '../utils/scrollManager'

import { saveSearchState } from '../store/actions'

const SearchActionsGeneric = ({sortingPanel = null, filtersPanel = null, applyLabel, newsroomList = false}) => {
  const dispatch = useDispatch()

  // local state
  const [isOpen, setIsOpen] = useState(false)
  const [isHidden, setIsHidden] = useState(false)
  const [currentPanel, setCurrentPanel] = useState(null)

  //reudx lang
  const lang = useSelector(state => state.lang)
  const savedSearchState = useSelector(state => state.savedSearchState)
  const [tempSearchState, setTempSearchState] = useState(null)

  // manage filters number on mobile for newsroom list
  const filtersThemesNumber = useSelector(state => state.filtersThemesNumber)
  const filtersYearNumber = useSelector(state => state.filtersYearNumber)
  const filtersTypeNumber = useSelector(state => state.filtersTypeNumber)
  const filtersProfilesNumber = useSelector(state => state.filtersProfilesNumber)
  const filtersHolderNumber = useSelector(state => state.filtersHolderNumber)
  let totalFilters = filtersYearNumber + filtersThemesNumber + filtersTypeNumber + filtersProfilesNumber + filtersHolderNumber
  let searchContainer = useRef(null)

  useLayoutEffect(() => {
    searchContainer.current = document.querySelector('.search-container-wrapper')
  }, [searchContainer])

  const closePanel = () => {
    setIsOpen(false);
    setCurrentPanel(null)

    scrollManager.restart()

    const contentOffset = document.querySelector('.search-actions-content').parentNode.offsetTop
    let offset = (window.innerWidth >= 768) ? 91 : 72
    window.scrollTo({
      top: contentOffset - offset
    })
  }

  const openPanel = (panel) => {
    setIsOpen(true)
    setCurrentPanel(panel)
    
    setTimeout(() => {
      scrollManager.stop()
    }, 280)
  }

  const handleScroll = () => {
    let offset = (window.innerWidth >= 768) ? 91 : 72

    if (window.innerWidth < 1024 && searchContainer.current !== null) {
      if (window.pageYOffset > searchContainer.current.offsetTop + searchContainer.current.offsetHeight - window.innerHeight + offset) {
        setIsHidden(true)
      } else {
        setIsHidden(false)
      }
    }
  }

  // scroll event listener
  useEventListener('scroll', handleScroll)

  return (
    <div className={`search-actions ${newsroomList ? 'search-actions--newsroom' : ''} ${isOpen ? 'is-open' : ''} ${isHidden ? 'is-hidden' : ''}`}>
      {/* buttons line */}
      <div className={`flex lg:hidden bg-light-grey search-actions__buttons ${isOpen ?'is-open' : ''}`}>
        { sortingPanel &&
          <button className={`search-actions__button ${currentPanel === 'sort' && 'is-active'}`} onClick={() => { openPanel('sort'); setTempSearchState(savedSearchState);}}>
            {trads[lang].search.order}
          </button>
        }
        <button className={`search-actions__button ${sortingPanel === null && 'search-actions__button--full'} ${(currentPanel === 'filters' || (sortingPanel === null && isOpen)) && 'is-active'}`} onClick={() => { openPanel('filters'); setTempSearchState(savedSearchState);}}>
          {trads[lang].search.filter}
          {(newsroomList && totalFilters > 0 && !isOpen) && <span className="newsroom-accordion__count newsroom-accordion__count--mobile center">{ totalFilters}</span>}
        </button>
      </div>
      
      {/* close */}
      <ButtonClose  isSmall={true} action={() => {closePanel(); dispatch(saveSearchState(tempSearchState))}} color="night" className="search-actions__close"  />
      
      <div className="search-actions__inner">
        <div className="relative flex-grow flex lg:block pb-8 lg:pb-0">
          {/* sorting */}
          { sortingPanel &&
            <div className={`search-actions__panel lg:mb-10 ${currentPanel === 'sort' && 'is-active'}`}>
              <div className="mt-9 lg:mt-0">
                {sortingPanel}
              </div>

              <div className="flex lg:hidden justify-center mt-6 flex-shrink-0">
                <ButtonArrow text={applyLabel} color="night" action={() => {closePanel()}} />
              </div>
            </div>
          }

          {/* filters */}
          <div className={`search-actions__panel ${currentPanel === 'filters' && 'is-active'}`}>
            <div>
              {filtersPanel}
            </div>

            <div className="flex lg:hidden justify-center mt-6 flex-shrink-0">
              <ButtonArrow text={applyLabel} color="night" action={() => {closePanel()}} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SearchActionsGeneric
